<template>
  <div>
    <main class="content-500 pad-16">
      <div v-if="page == 'list'">
        <div style="margin-top: 80px; margin-bottom: 8px;">
          <button @click="page = 'overview'" class="button color-white">
            Zurück
          </button>
        </div>
        <section class="br-10 pad-24" style="background-color:  var(--second-bg-color);">
          <h3 style="font-size: 1.4em;" class="f-bold t-center">
            Hinterlegte Muttizettel
          </h3>
          <div v-if="muttizettelList == 0" class="t-center">
            <div class="pad-4" />
            <p style="font-size: 0.8em; color: #ffffff80">
              Es wurden noch keine Muttizettel hinterlegt
            </p>
            <button @click="page = 'new'" style="margin-top: 16px;" class="button bgcolor-blue color-white">
              Muttizettel anlegen
            </button>
          </div>
        </section>
        <article v-for="muttizettel in muttizettelList" :key="muttizettel.id" class="br-10" style="background-color:  var(--second-bg-color);margin-top: 16px;">
          <div class="bgcolor-blue pad-24">
            {{ muttizettel.startTime.split(' ')[0].split('-')[2] + '.' + muttizettel.startTime.split(' ')[0].split('-')[1] + ' - ' + muttizettel.title }}
          </div>
          <div class="pad-24">
            <h6 class="f-bold color-white" style="margin-bottom: 8px;">
              Deine Angaben
            </h6>
            <table style="width: 100%">
              <tr>
                <td>Dein Name:</td>
                <td>{{ muttizettel.nameUser }}</td>
              </tr>
              <tr>
                <td>Deine Aufsichtsperson:</td>
                <td>{{ muttizettel.nameSupervisor }}</td>
              </tr>
            </table>
            <button @click="openDetails(muttizettel.id)" style="margin-top: 16px;" class="button bgcolor-blue color-white fluid">
              Details anzeigen
            </button>
          </div>
        </article>
      </div>
      <div v-if="page == 'overview'">
        <section class="br-10 pad-24" style="background-color:  var(--second-bg-color); margin-top: 80px;">
          <div style="margin-bottom: 12px;">
            <span class="bgcolor-blue pad-8 br-10" style="font-size: 0.8em;">MUTTIZETTEL</span>
          </div>
          <h2 class="color-white f-normal" style="font-size: 1.6em;">
            Dein Clubzettel für eine unvergessliche Nacht. 🎉
          </h2>
          <h3 class="f-light" style="color: #ffffff66; font-size: 1.1em; margin-top: 8px;">
            Sie sagten, feiern kannst du auch noch später? Nicht mit uns! Deine Zeit ist jetzt - und die guten Partys am Wochenende!
          </h3>
        </section>
        <div style="margin-top: 16px;">
          <button class="button bgcolor-blue color-white fluid" @click="page = 'new'">
            <svg width="48px" fill="none" viewBox="0 0 142 175" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#a)" fill="#ffffff" class="fill-000000"><path d="M140.752 92.915c.179 16.504.42 33.008.506 49.513.031 5.833-.427 11.667-.459 17.502-.046 8.37-6.514 13.468-14.13 13.632-15.602.338-31.21.699-46.812.621-18.078-.09-36.157-.566-54.23-1.044a102.916 102.916 0 0 1-13.046-1.416c-4.962-.773-9.834-6.703-10.099-12.102-.262-5.378-.475-10.76-.545-16.142a28666.69 28666.69 0 0 1-.878-75.128C.9 53.64.837 38.928.612 24.218c-.066-4.17-.367-8.353 1.32-12.268A25.62 25.62 0 0 1 5.58 5.597c1.864-2.22 4.614-3.061 7.554-3.142 6.06-.166 12.13-.205 18.176-.605 21.335-1.41 42.666-.308 64-.15 4.538.034 7.988 1.517 11.335 4.698 6.832 6.492 14.164 12.456 21.248 18.685 2.697 2.371 5.199 4.967 7.936 7.286 2.525 2.14 3.505 4.833 3.6 8.003.167 5.611.433 11.22.512 16.832.166 11.904.239 23.809.351 35.713l.461-.002ZM93.45 10.102c-1.939-.158-3.595-.387-5.254-.416-14.145-.239-28.29-.456-42.434-.652-6.394-.089-12.79-.124-19.184-.163-3.25-.02-6.505-.123-9.746.042-4.635.236-5.997 1.58-6.826 6.27a43.112 43.112 0 0 0-.483 12.733c.22 1.782.336 3.576.346 5.372.074 40.08.137 80.159.187 120.236-.04 1.01-.003 2.021.111 3.024.806 5.12 3.505 8.229 9.09 8.455 21.664.874 43.329.869 65 .504 11.001-.185 22.004-.275 33.006-.401 2.691-.031 5.389.076 8.073-.065 4.419-.239 6.755-2.662 6.705-7.103-.053-4.932-.418-9.862-.501-14.794-.096-5.724.098-11.454-.066-17.175-.403-14.249-1.098-28.49-1.37-42.74-.223-11.672 0-23.35.01-35.027 0-.941-.114-1.883-.155-2.503-3.898 0-7.373-.013-10.849.004-3.593.017-7.189.153-10.778.066a30.125 30.125 0 0 1-6.33-.722c-4.248-1.033-5.552-2.663-6.047-6.969-.14-1.225-.147-2.465-.262-3.694-.723-7.931-1.462-15.858-2.243-24.282Zm12.103 27.544 19.362-1.193.295-.652c-7.662-6.52-14.864-13.55-22.939-19.795 1.073 7.068 2.144 14.137 3.282 21.64Z" /><path d="m64.558 110.884 19.444-18.51a16.82 16.82 0 0 0-2.177-.247c-14.813.544-29.628 1.075-44.439 1.692-3.36.14-6.705.644-10.064.868a18.084 18.084 0 0 1-3.989-.244 2.12 2.12 0 0 1-1.478-.765 2.11 2.11 0 0 1-.465-1.598 4.498 4.498 0 0 1 1.335-2.827 6.973 6.973 0 0 1 3.462-1.09c10.505-.94 21.003-2.002 31.53-2.625 9.411-.556 18.853-.61 28.282-.861 2.015-.054 4.033-.008 6.498-.008 3.18-3.15 6.585-6.564 10.042-9.924 2.257-2.197 3.648-2.475 5.996-1.151a7.253 7.253 0 0 1 1.934 1.822c2.32 2.887 4.595 5.808 6.877 8.729 2.741 3.51 2.363 5.895-1.008 8.972-6.202 5.662-12.29 11.447-19.014 17.732 5.528-.204 10.154-.384 14.781-.537a15.588 15.588 0 0 1 2.68.099 2.806 2.806 0 0 1 2.582 2.674c.174 1.501-.413 2.848-1.82 3.255-1.932.558-3.924.88-5.933.956-6.276.23-12.56.296-19.224.432-4.138 4.382-8.305 8.907-12.622 13.283a10.977 10.977 0 0 1-3.944 2.413c-3.362 1.247-6.94 1.963-10.203 3.41-5.227 2.319-10.662 2.197-16.156 2.254-6.4.066-12.799.376-19.196.514-1.346.04-2.69-.09-4.004-.386a2.702 2.702 0 0 1-2.278-2.917 2.853 2.853 0 0 1 2.444-2.822 17.863 17.863 0 0 1 3.348-.225c9.429-.238 18.858-.455 28.288-.704.876-.023 1.748-.218 2.761-.351 1.12-4.599 1.116-9.152 1.09-14.193h-3.742c-9.324.018-18.647.066-27.97.027a16.45 16.45 0 0 1-4.266-.677 2.452 2.452 0 0 1-1.813-2.861 2.33 2.33 0 0 1 .696-1.503c.409-.398.95-.63 1.519-.656a39.845 39.845 0 0 1 4.67-.591c9.2-.322 18.402-.605 27.605-.848 2.68-.074 5.37-.011 7.94-.011Zm30.705-21.637c-9.606 9.195-19.512 17.499-28.63 26.902l10.116 8.073c8.574-8.853 16.943-17.495 25.359-26.188l-6.845-8.787Zm5.42-3.83 7.323 6.856 4.362-4.092-6.425-9.132-5.26 6.368Zm-36.36 34.998c.077 3.376-.601 6.144.176 8.912 3.795-.577 4.988-1.017 6.845-2.53l-7.022-6.382ZM69.995 70.03c-9.534.46-19.064.99-28.6 1.362-5.16.201-10.332.14-15.498.182a6.675 6.675 0 0 1-1.67-.17 2.668 2.668 0 0 1-2.218-2.606 2.725 2.725 0 0 1 2.363-2.83 12.905 12.905 0 0 1 2.01-.155c13.221-.807 26.44-1.665 39.665-2.398 7.399-.409 14.81-.59 22.214-.912 7.292-.319 14.58-.71 21.871-1.018a41.228 41.228 0 0 1 6.381.049c2.391.272 3.522 1.556 3.501 3.365-.021 1.844-1.141 2.954-3.564 3.255-2.339.292-4.695.51-7.05.596-13.131.481-26.263.937-39.397 1.367l-.008-.086Z" /></g><defs><clipPath id="a"><path fill="#ffffff" transform="translate(.408 .574)" d="M0 0h141.113v173.93H0z" class="fill-ffffff" /></clipPath></defs></svg>
            <span style="display: block; font-size: 1.4em; margin-top: 8px;">Neuen Muttizettel erstellen</span>
          </button>
        </div>
        <div style="margin-top: 16px;">
          <button class="button bgcolor-blue color-white fluid" @click="page = 'list'">
            <svg width="48px" fill="none" viewBox="0 0 139 164" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#a)" fill="#ffffff" class="fill-000000"><path d="M138.217 84.046c0 14.78.045 29.559-.03 44.339a84.803 84.803 0 0 1-.694 11.329c-1.003 7.138-4.732 12.692-10.745 16.7a31.648 31.648 0 0 1-14.792 5.387c-20.08 2-40.304 2.124-60.407.37-7.958-.693-15.999-.717-23.744-2.917a76.216 76.216 0 0 1-11.782-4.152c-7.314-3.459-11.733-9.345-13.451-17.294a62.137 62.137 0 0 1-1.658-13.497c.124-25.391.211-50.783.26-76.176.084-7.58.67-15.146 1.755-22.65a38.76 38.76 0 0 1 2.603-9.84C9.076 7.293 15.356 2.243 24.666 1.702 34.92 1.106 45.184.57 55.451.342 64.96.126 74.482.2 83.991.427c7.22.174 14.43.778 21.643 1.216a9.808 9.808 0 0 1 5.259 1.957 152.103 152.103 0 0 1 25.039 23.163c2.129 2.438 2.718 5.202 2.669 8.397-.265 16.293-.367 32.588-.527 48.883l.143.002Zm-63.163 71.527c9.524-.346 20.156-.713 30.789-1.132a68.582 68.582 0 0 0 6.811-.592 17.001 17.001 0 0 0 9.125-4.32c3.822-3.418 6.379-7.564 6.834-12.69.435-4.892.567-9.816.708-14.729.26-9.075.446-18.15.628-27.225.083-4.16.464-8.358.05-12.473-1.03-10.206-.638-20.419-.673-30.628a416.38 416.38 0 0 0-.181-11.344c-.056-1.865-1.73-3.315-3.84-3.386-4.937-.168-9.879-.209-14.812-.45a47.238 47.238 0 0 1-6.753-.901c-1.992-.39-4.076-2.846-4.301-4.85a42.826 42.826 0 0 1-.326-4.517c-.027-4.538.03-9.075.025-13.613a3.428 3.428 0 0 0-.866-2.01 3.451 3.451 0 0 0-1.91-1.08c-1.135-.103-2.27-.233-3.407-.252-14.06-.242-28.12-.518-42.18-.667-5.697-.06-11.397.172-17.096.276-4.192.103-8.332.95-12.225 2.502-5.433 2.115-8.518 6.165-9.025 11.988a40.198 40.198 0 0 0 .056 5.668c.69 12.482.439 24.964.192 37.454-.383 19.296-.599 38.597-.755 57.896-.07 4.54.189 9.079.775 13.582a14.499 14.499 0 0 0 2.675 6.821 14.571 14.571 0 0 0 5.676 4.656 34.648 34.648 0 0 0 7.493 2.593 87.305 87.305 0 0 0 16.905 2.352c9.5.269 18.993.677 29.608 1.071Zm39.472-126.504c1.822-.096 3.32-.075 4.769-.3.536-.084 1.048-.693 1.432-1.173a1.125 1.125 0 0 0-.158-1.012 37.705 37.705 0 0 0-9.711-8.909 2.094 2.094 0 0 0-1.652.458c-.137 2.917-.206 5.844-.095 8.761a2.24 2.24 0 0 0 1.376 1.564c1.329.3 2.68.503 4.039.61Z" /><path d="M69.001 56.371c11.026.152 22.052.284 33.077.47 2.661.017 5.319.174 7.963.47 1.482.287 2.927.741 4.306 1.352 1.141.42 2.457 2.484 2.418 3.616-.038 1.108-1.562 3.134-2.572 3.53-3.601 1.41-7.376 1.689-11.184 1.745-7.605.11-15.212.394-22.812.259-9.878-.178-19.75-.682-29.624-1.075-6.078-.242-12.155-.504-18.227-.832a8.31 8.31 0 0 1-5.25-1.928 3.646 3.646 0 0 1-1.453-2.926c.065-1.303 1.253-3.278 2.408-3.488a32.532 32.532 0 0 1 5.592-.764c11.787-.07 23.575-.035 35.362-.035l-.004-.394ZM72.558 84.853c-10.484-.273-20.747-.48-31.004-.84a84.75 84.75 0 0 1-10.185-1.017 11.714 11.714 0 0 1-4.073-1.823 2.515 2.515 0 0 1-.74-2.932c.142-.333.353-.632.62-.877a7.08 7.08 0 0 1 3.037-1.36 62.926 62.926 0 0 1 7.935-.643c15.586-.147 31.177-.468 46.758-.215 9.101.148 18.188 1.243 27.278 1.957a8.784 8.784 0 0 1 2.148.72c1.011.365 2.391 2.763 1.926 3.724-.465.962-1.124 2.075-2.006 2.525-3.125 1.592-6.604 1.645-10.025 1.632-10.636-.042-21.296.762-31.669-.851ZM70.519 94.941c11.036.15 22.074.28 33.11.464 2.281.014 4.56.17 6.822.468 1.077.153 2.097.828 3.1 1.348 1.08.56 2.17 2.912 1.641 3.905-.509.953-1.254 2.039-2.174 2.457a11.52 11.52 0 0 1-4.39.921c-9.512.238-19.027.524-28.54.5-9.513-.025-19.036-.203-28.536-.677-6.828-.341-13.632-1.236-20.434-1.997a5.795 5.795 0 0 1-3.048-1.345 6.65 6.65 0 0 1-1.558-2.83c-.235-.705 1.154-2.513 1.852-2.601a57.596 57.596 0 0 1 6.755-.728c11.799-.072 23.599-.033 35.398-.033l.002.148ZM58.378 123.588c-7.924-.286-15.85-.546-23.771-.875a13.508 13.508 0 0 1-7.476-2.274 4.347 4.347 0 0 1-1.863-3.846c.026-1.318 1.421-2.931 2.624-3.402 3.262-1.279 6.658-1.203 10.059-1.057 9.807.419 19.623.728 29.418 1.35 6.017.382 12.004 1.241 18 1.929.735.157 1.455.378 2.152.66.673.201 2.046 1.989 1.758 2.664-.413.972-.911 2.175-1.742 2.647a10.137 10.137 0 0 1-4.254 1.238c-5.65.364-11.31.584-16.97.778-2.64.093-5.287.017-7.93.017l-.005.171ZM43.153 45.444c-3.688-.231-7.876-.367-12.025-.815a19.766 19.766 0 0 1-5.418-1.62 3.007 3.007 0 0 1-1.81-2.654c-.092-1.267 1.224-3.226 2.363-3.51.359-.124.726-.223 1.1-.297 9.088-.957 18.187-1.378 27.3-.347a6.82 6.82 0 0 1 2.16.663 4.658 4.658 0 0 1 1.748 1.38c.461.594.771 1.29.903 2.03.222 1.123-1.14 3.216-2.32 3.609a14.586 14.586 0 0 1-3.255.937c-3.41.284-6.831.41-10.746.624Z" /></g><defs><clipPath id="a"><path fill="#ffffff" transform="translate(.777)" d="M0 0h138v164H0z" class="fill-ffffff" /></clipPath></defs></svg>
            <span style="display: block; font-size: 1.4em; margin-top: 8px;">Hinterlegte Zettel ansehen</span>
          </button>
        </div>
      </div>
      <div v-if="page == 'new'" id="Outline" class="br-10 pad-24" style="background-color:  var(--second-bg-color); margin-top: 80px;">
        <div v-if="step <= 5">
          <h4 class="t-center">
            Schritt {{ step +1 }} von 6 - Veranstaltung
          </h4>
          <div class="progressBox" style="margin: 16px auto 24px auto">
            <div id="progressBar" />
          </div>
        </div>
        <section v-if="step === 0">
          <div class="t-center" style="margin-bottom: 16px;">
            <h2 style="font-size: 1em;" class="color-blue f-bold">
              Jetzt ausfüllen und den Clubzettel erhalten️
            </h2>
            <h3 style="font-size: 0.8em;">
              Bitte gib an, um welche Veranstaltung es sich handelt.
            </h3>
          </div>
          <div class="field simple">
            <label style="padding-bottom: 6px;">Event auswählen</label>
            <select v-model="eventId">
              <option value="-1" disabled>
                Event...
              </option>
              <option v-for="event in events" :key="event.id" :value="event.id">
                {{ event.startTime.split(' ')[0].split('-')[2] + '.' + event.startTime.split(' ')[0].split('-')[1] + ' - ' + event.title }}
              </option>
            </select>
          </div>
          <button class="button bgcolor-black color-white fluid" @click="page = 'overview'">
            Abbrechen
          </button>
          <div class="pad-4" />
          <button class="button bgcolor-blue color-white fluid" @click="checkStep">
            Weiter
          </button>
        </section>
        <section v-if="step === 1">
          <div class="t-center" style="margin-bottom: 16px;">
            <h3 style="font-size: 0.8em;">
              Bitte gib die Daten der sorgeberechtigten Person ein. (z.B. Vater oder Mutter)
            </h3>
          </div>
          <div class="field simple">
            <label style="padding-bottom: 6px" for="parentName">👤 Name Elternteil<span class="color-red">*</span></label>
            <input id="parentName" placeholder="Vor- & Nachname Elternteil" v-model="parentName" :class="{errorInput : errors.parentName }" @change="errors.parentName=false">
          </div>
          <div class="field simple">
            <label style="padding-bottom: 6px" for="eventDate">🏡 Anschrift Elternteil<span class="color-red">*</span></label>
            <input id="address" placeholder="Straße, Hausnummer" v-model="parentAddress" :class="{errorInput : errors.parentAddress }" @change="errors.parentAddress=false">
          </div>
          <div class="grid-12">
            <div class="col-sp-4 row-sp-12">
              <div class="field simple">
                <input id="plz" placeholder="Postleitzahl" v-model="parentPlz" type="number" :class="{errorInput : errors.parentPlz }" @change="errors.parentPlz=false">
              </div>
            </div>
            <div class="col-sp-8 row-sp-12" style="padding-left: 4px;">
              <div class="field simple">
                <input id="city" placeholder="Stadt" v-model="parentCity" :class="{errorInput : errors.parentCity }" @change="errors.parentCity=false">
              </div>
            </div>
          </div>
          <div class="field simple">
            <select id="country" v-model="parentCountry" :class="{errorInput : errors.parentCountry }" @change="errors.parentCountry=false">
              <option selected value="Deutschland">
                Deutschland
              </option>
              <option value="Österreich">
                Österreich
              </option>
              <option value="Schweiz">
                Schweiz
              </option>
            </select>
          </div>
          <div class="field simple">
            <label style="padding-bottom: 6px" for="parentPhone">📞Telefon Elternteil<span class="color-red">*</span></label>
            <input id="parentPhone" type="tel" placeholder="Telefonnummer" v-model="parentPhone" :class="{errorInput : errors.parentPhone }" @change="errors.parentPhone=false">
          </div>
          <div class="field simple">
            <label style="padding-bottom: 6px" for="parentBirthday">🎈Geburtsdatum Elternteil<span class="color-red">*</span></label>
            <input id="parentBirthday" type="date" v-model="parentBirthyday" :class="{errorInput : errors.parentBirthday }" @change="errors.parentBirthday=false">
          </div>
          <div class="grid-12">
            <div class="col-sp-6 row-sp-12" style="padding-right: 4px;">
              <button class="button bgcolor-black color-white fluid" @click="()=>{step --}">
                Zurück
              </button>
            </div>
            <div class="col-sp-6 row-sp-12" style="padding-left: 4px;">
              <button class="button bgcolor-blue color-white fluid" @click="checkStep">
                Weiter
              </button>
            </div>
          </div>
        </section>
        <section v-if="step === 2">
          <div class="t-center" style="margin-bottom: 16px;">
            <h3 style="font-size: 0.8em;">
              Bitte gib die Daten der unter 18 jährigen Person ein.
            </h3>
          </div>
          <div class="field simple">
            <label style="padding-bottom: 6px" for="parentName">👤Name unter 18<span class="color-red">*</span></label>
            <input id="parentName" placeholder="Vor- & Nachname unter 18" v-model="username" :class="{errorInput : errors.username }" @change="errors.username=false">
          </div>
          <div class="field simple">
            <label style="padding-bottom: 6px" for="eventDate">🏡Anschrift unter 18<span class="color-red">*</span></label>
            <button class="button bgcolor-black tiny color-white fluid" @click="()=>{address = parentAddress;city = parentCity;plz = parentPlz;country = parentCountry;errors.parentAddress = false;errors.parentCity = false;errors.parentPlz = false;errors.parentCountry = false;}">
              Adresse vom Elternteil übernehmen
            </button>
          </div>
          <div class="field simple">
            <input id="address" placeholder="Straße, Hausnummer" v-model="address" :class="{errorInput : errors.address }" @change="errors.address=false">
          </div>
          <div class="grid-12">
            <div class="col-sp-4 row-sp-12">
              <div class="field simple">
                <input id="plz" placeholder="Postleitzahl" v-model="plz" type="number" :class="{errorInput : errors.plz }" @change="errors.plz=false">
              </div>
            </div>
            <div class="col-sp-8 row-sp-12" style="padding-left: 4px;">
              <div class="field simple">
                <input id="city" placeholder="Stadt" v-model="city" :class="{errorInput : errors.city }" @change="errors.city=false">
              </div>
            </div>
          </div>
          <div class="field simple">
            <select id="country" v-model="country" :class="{errorInput : errors.country }" @change="errors.country=false">
              <option selected value="Deutschland">
                Deutschland
              </option>
              <option value="Österreich">
                Österreich
              </option>
              <option value="Schweiz">
                Schweiz
              </option>
            </select>
          </div>
          <div class="field simple">
            <label style="padding-bottom: 6px" for="parentPhone">📞Telefon unter 18<span class="color-red">*</span></label>
            <input id="parentPhone" placeholder="Telefonnummer" type="tel" v-model="phone" :class="{errorInput : errors.phone }" @change="errors.phone=false">
          </div>
          <div class="field simple">
            <label style="padding-bottom: 6px" for="parentBirthday">🎈Geburtsdatum unter 18<span class="color-red">*</span></label>
            <input id="parentBirthday" type="date" v-model="birthyday" :class="{errorInput : errors.birthday }" @change="errors.birthday=false">
            <span class="color-red t-center" v-if="errors.birthday">{{ errors.birthdayMessage }}</span>
          </div>
          <div class="grid-12">
            <div class="col-sp-6 row-sp-12" style="padding-right: 4px;">
              <button class="button bgcolor-black color-white fluid" @click="()=>{step --}">
                Zurück
              </button>
            </div>
            <div class="col-sp-6 row-sp-12" style="padding-left: 4px;">
              <button class="button bgcolor-blue color-white fluid" @click="checkStep">
                Weiter
              </button>
            </div>
          </div>
        </section>
        <section v-if="step === 3">
          <div class="t-center" style="margin-bottom: 16px;">
            <h3 style="font-size: 0.8em;">
              Bitte gib die Daten der Aufsichtsperson an (über 18 Jahre alt).
            </h3>
          </div>
          <div class="field simple">
            <h6 class="f-bold color-blue">
              Aufsichtsperson später eintragen
            </h6>
            <input type="checkbox" id="supervisorLater" v-model="supervisorLater" style="display: inline; width: auto; margin-right: 4px;">
            <label for="supervisorLater" style="display: inline; font-weight: normal;">Ja, ich möchte die Aufsichtsperson nach dem Ausdruck eintragen</label>
          </div>
          <p style="font-size: 0.8em; margin-bottom: 8px;">
            Falls du die Aufsichtsperson noch nicht hier eintragen möchtest kannst du diese auch später auf dem Clubzettel nachtragen.
            Bitte beachte dabei, dass du den Muttizettel im Nachgang ausdrucken musst, da dieser nur in der App hinterlegt werden kann,
            wenn dieser vollständig online ausgefüllt wurde.
          </p>
          <div v-if="!supervisorLater">
            <div class="field simple">
              <label style="padding-bottom: 6px" for="parentName">Name Aufsichtsperson (18+) 👤<span class="color-red">*</span></label>
              <input id="parentName" placeholder="Vor- & Nachname über 18" v-model="supervisorName" :class="{errorInput : errors.supervisorName }" @change="errors.supervisorName=false">
            </div>
            <div class="field simple">
              <label style="padding-bottom: 6px" for="eventDate">Anschrift Aufsichtsperson (18+) 🏡<span class="color-red">*</span></label>
              <button class="bgcolor-black color-white button fluid tiny" @click="()=>{supervisorAddress = parentAddress;supervisorCity = parentCity;supervisorPlz = parentPlz;supervisorCountry = parentCountry;errors.supervisorAddress = false;errors.supervisorCity = false;errors.supervisorPlz = false;errors.supervisorCountry = false;}">
                Adresse vom Elternteil übernehmen
              </button>
            </div>
            <div class="field simple">
              <input id="address" placeholder="Straße, Hausnummer" v-model="supervisorAddress" :class="{errorInput : errors.supervisorAddress }" @change="errors.supervisorAddress=false">
            </div>
            <div class="grid-12">
              <div class="col-sp-4 row-sp-12">
                <div class="field simple">
                  <input id="plz" placeholder="Postleitzahl" v-model="supervisorPlz" type="number" :class="{errorInput : errors.supervisorPlz }" @change="errors.supervisorPlz=false">
                </div>
              </div>
              <div class="col-sp-8 row-sp-12" style="padding-left: 4px;">
                <div class="field simple">
                  <input id="city" placeholder="Stadt" v-model="supervisorCity" :class="{errorInput : errors.supervisorCity }" @change="errors.supervisorCity=false">
                </div>
              </div>
            </div>
            <div class="field simple">
              <select id="country" v-model="supervisorCountry" :class="{errorInput : errors.supervisorCountry }" @change="errors.supervisorCountry=false">
                <option selected value="Deutschland">
                  Deutschland
                </option>
                <option value="Österreich">
                  Österreich
                </option>
                <option value="Schweiz">
                  Schweiz
                </option>
              </select>
            </div>
            <div class="field simple">
              <label style="padding-bottom: 6px" for="supervisorEmail">✉️E-Mail Aufsichtsperson (18+)<span class="color-red">*</span></label>
              <input id="supervisorEmail" placeholder="E-Mail-Adresse" type="email" v-model="supervisorEmail" :class="{errorInput : errors.supervisorEmail }" @change="errors.supervisorEmail=false">
            </div>
            <div class="field simple">
              <label style="padding-bottom: 6px" for="supervisorPhone">📞Telefon Aufsichtsperson (18+)<span class="color-red">*</span></label>
              <input id="supervisorPhone" placeholder="Telefonnummer" type="tel" v-model="supervisorPhone" :class="{errorInput : errors.supervisorPhone }" @change="errors.supervisorPhone=false">
            </div>
            <div class="field simple">
              <label style="padding-bottom: 6px" for="supervisorBirthday">🎈Geburtsdatum (18+)<span class="color-red">*</span></label>
              <input id="supervisorBirthday" type="date" v-model="supervisorBirthyday" :class="{errorInput : errors.supervisorBirthyday }" @change="errors.supervisorBirthyday=false">
              <span class="color-red t-center" v-if="errors.supervisorBirthyday">{{ errors.supervisorBirthydayMessage }}</span>
            </div>
          </div>
          <div class="grid-12">
            <div class="col-sp-6 row-sp-12" style="padding-right: 4px;">
              <button class="button bgcolor-black color-white fluid" @click="()=>{step --}">
                Zurück
              </button>
            </div>
            <div class="col-sp-6 row-sp-12" style="padding-left: 4px;">
              <button class="button bgcolor-blue color-white fluid" @click="checkStep">
                Weiter
              </button>
            </div>
          </div>
        </section>
        <section v-if="step === 4">
          <div v-if="!signatureLaterCheck">
            <div class="t-center" style="margin-bottom: 16px;">
              <h3 style="font-size: 0.8em;">
                Unterschrift des Elternteils bzw. der sorgeberechtigten Person
              </h3>
            </div>
            <div style="border: 1px solid black; background-color: #ffffff50;" v-if="!errors.signatureLater" :class="{errorInput: errors.signature}">
              <VueSignaturePad width="100%" height="180px" ref="signaturePad" />
              <div class="grid-12">
                <div class="col-sp-12 row-sp-12">
                  <button class="button tiny fluid" style="border-radius: 0;" @click="undo">
                    Rückgängig
                  </button>
                </div>
              </div>
            </div>
            <p style="margin: 16px 0; font-size: 0.8em;">
              Hiermit erkläre ich mich als sorgeberechtigte Person einverstanden, dass ich die Aufsicht an die angegebene Person übertrage.
            </p>
            <div class="t-center" style="margin-bottom: 16px;">
              <h3 style="font-size: 0.8em;">
                Unterschrift des Elternteils bzw. der sorgeberechtigten Person
              </h3>
            </div>
            <div style="border: 1px solid black; background-color: #ffffff50;" v-if="!errors.signatureLater" :class="{errorInput: errors.signature}">
              <VueSignaturePad width="100%" height="180px" ref="signaturePad2" />
              <div class="grid-12">
                <div class="col-sp-12 row-sp-12">
                  <button class="button tiny fluid" style="border-radius: 0;" @click="undo2">
                    Rückgängig
                  </button>
                </div>
              </div>
            </div>
            <p style="margin: 16px 0; font-size: 0.8em;">
              Hiermit erkläre ich mich als sorgeberechtigte Person einverstanden, dass ich die Aufsicht an die angegebene Person übertrage.
            </p>
          </div>
          <div style="margin-bottom: 16px;">
            <input type="checkbox" v-model="signatureLaterCheck" id="signatureLater" @click="signatureLater">
            <label for="signatureLater" style="font-size: 0.9em; margin-left: 4px;">Der Clubzettel soll nicht online unterschrieben werden</label>
            <p v-if="signatureLaterCheck" style="font-size: 0.8em;">
              Bitte beachte dabei, dass du den Muttizettel im Nachgang ausdrucken musst, da dieser nur in der App hinterlegt werden kann,
              wenn dieser vollständig online ausgefüllt wurde.
            </p>
          </div>

          <div class="grid-12">
            <div class="col-sp-6 row-sp-12" style="padding-right: 4px;">
              <button class="button bgcolor-black color-white fluid" @click="()=>{step --}">
                Zurück
              </button>
            </div>
            <div class="col-sp-6 row-sp-12" style="padding-left: 4px;">
              <button class="button bgcolor-blue color-white fluid" @click="checkStep">
                Weiter
              </button>
            </div>
          </div>
        </section>
        <section v-if="step === 5">
          <div class="t-center" style="margin-bottom: 16px;" v-if="!user.email">
            <h3 style="font-size: 1em;">
              Wohin soll der Clubzettel geschickt werden?
            </h3>
            <div class="field simple">
              <input id="email" placeholder="E-Mail-Adresse" v-model="sendEmail" :class="{errorInput : errors.sendEmail }" @change="errors.sendEmail=false">
            </div>
          </div>
          <div style="margin-bottom: 8px;">
            <input type="checkbox" id="privacy" v-model="privacy" required>
            <label for="privacy" style="font-size: 0.9em; margin-left: 4px;">Ich stimme der Datenschutzerklärung zu.</label>
          </div>
          <div style="margin-bottom: 16px;">
            <p class="bgcolor-black color-white br-10 pad-12" style="font-size: 0.8em;">
              Bei unseren U18-Formular werden Deine Daten in unserer Datenbank zur Verarbeitung und Generierung des Clubzettels sowie zum Zweck der Analyse und Überprüfung der Informationen gespeichert. Du kannst der künftigen Verarbeitung der Dir betreffenden Daten nach Maßgabe des Art. 21 DSGVO jederzeit widersprechen.
            </p>
          </div>
          <div style="margin-bottom: 8px;">
            <input type="checkbox" id="newsletter" v-model="newsletter" required>
            <label for="newsletter" style="font-size: 0.9em; margin-left: 4px;">
              Ich stimme zu bspw. über neue Partys in meiner Stadt informiert zu werden.
            </label>
          </div>
          <div style="margin-bottom: 16px;">
            <p class="bgcolor-black color-white br-10 pad-12" style="font-size: 0.8em;">
              Bei unseren Newslettern (Online, Handy/SMS und postaler Weg) werden Deine Daten in unserer Datenbank zum Zweck der Analyse und zum Versand gespeichert. Du kannst der künftigen Verarbeitung der Dir betreffenden Daten nach Maßgabe des Art. 21 DSGVO jederzeit widersprechen.
            </p>
          </div>
          <div class="grid-12">
            <div class="col-sp-6 row-sp-12" style="padding-right: 4px;">
              <button class="button bgcolor-black color-white fluid" @click="()=>{step --}">
                Zurück
              </button>
            </div>
            <div class="col-sp-6 row-sp-12" style="padding-left: 4px;">
              <button class="button bgcolor-blue color-white fluid" @click="checkStep">
                Clubzettel erhalten
              </button>
            </div>
          </div>
        </section>
        <section v-if="step === 6">
          <div v-if="saveInApp == 1" class="t-center">
            <picture>
              <source srcset="https://fonts.gstatic.com/s/e/notoemoji/latest/1f973/512.webp" type="image/webp">
              <img src="https://fonts.gstatic.com/s/e/notoemoji/latest/1f973/512.gif" alt="🥳" width="80" height="80">
            </picture>
            <h3 style="font-size: 1.4em;" class="f-bold">
              Muttizettel hinterlegt
            </h3>
            <h4 class="color-blue">
              Dein Muttizettel wurde in der App hinterlegt
            </h4>
            <button @click="page = 'list'; step = 0" class="button bgcolor-blue color-white" style="margin-top: 16px;">
              Muttizettel ansehen
            </button>
          </div>
          <div v-else class="t-center">
            <picture>
              <source srcset="https://fonts.gstatic.com/s/e/notoemoji/latest/1f973/512.webp" type="image/webp">
              <img src="https://fonts.gstatic.com/s/e/notoemoji/latest/1f973/512.gif" alt="🥳" width="80" height="80">
            </picture>
            <h3 style="font-size: 1.4em;" class="f-bold">
              Muttizettel versendet
            </h3>
            <h4 class="color-blue">
              Wir haben dir deinen Muttizettel per E-Mail gesendet.
            </h4>
            <button @click="page = 'overview'; step = 0" class="button bgcolor-blue color-white" style="margin-top: 16px;">
              Zurück zur Übersicht
            </button>
          </div>
        </section>
        <div class="t-center">
          <p style="font-size: 0.6em; margin-top: 16px;">
            <svg style="vertical-align: -4px;" width="16px" baseProfile="tiny" viewBox="0 0 32 32" xml:space="preserve" xmlns="http://www.w3.org/2000/svg"><path d="M23 14v-2a7 7 0 1 0-14 0v2H7v13h18V14h-2zm-12-2c0-2.757 2.243-5 5-5s5 2.243 5 5v2H11v-2zm12 13H9v-9h14v9z" fill="#ffffff" class="fill-000000" /><path d="M15 20.611V23h2v-2.389c.305-.275.5-.668.5-1.111a1.5 1.5 0 0 0-3 0c0 .443.195.836.5 1.111z" fill="#ffffff" class="fill-000000" /></svg>
            Sichere Datenübertragung durch SSL SHA-256 Verschlüsselung
          </p>
        </div>
      </div>
      <div class="pad-40" />
      <transition name="modal" id="detailsModal">
        <div class="vueModal" v-if="detailsModal">
          <div class="vueModalOuter" @click="detailsModal = false;" />
          <div class="vueModalInner largeMax bgcolor-second">
            <div class="t-center pad-8">
              <h4 class="color-blue f-bold" style="font-size: 1.4em;">
                Muttizettel für
              </h4>
              <h5 class="color-white">
                {{ muttizettelDetails.startTime.split(' ')[0].split('-')[2] + '.' + muttizettelDetails.startTime.split(' ')[0].split('-')[1] + ' - ' + muttizettelDetails.title }}
              </h5>
            </div>
            <div style="overflow-y: scroll; max-height: 300px; font-size: 0.9em;" class="bgcolor-black pad-16 br-10">
              <b class="f-bold">Deine Daten</b>
              <table style="width: 100%;">
                <tr>
                  <td>Name:</td>
                  <td>{{ muttizettelDetails.nameUser }}</td>
                </tr>
                <tr>
                  <td>Adresse:</td>
                  <td>
                    {{ muttizettelDetails.streetUser }}<br>
                    {{ muttizettelDetails.plzUser }} {{ muttizettelDetails.cityUser }}<br>
                    {{ muttizettelDetails.countryUser }}
                  </td>
                </tr>
                <tr>
                  <td>Geburtstag:</td>
                  <td>{{ muttizettelDetails.dobUser.split('-')[2] + '.' + muttizettelDetails.dobUser.split('-')[1] + '.' + muttizettelDetails.dobUser.split('-')[0] }}</td>
                </tr>
                <tr>
                  <td>Telefonnummer:</td>
                  <td>{{ muttizettelDetails.phoneUser }}</td>
                </tr>
                <tr>
                  <td>E-Mail-Adresse:</td>
                  <td>{{ muttizettelDetails.emailUser }}</td>
                </tr>
              </table>
              <div class="pad-8" />
              <b class="f-bold">Daten von deiner Aufsichtsperson</b>
              <table style="width: 100%;">
                <tr>
                  <td>Name:</td>
                  <td>{{ muttizettelDetails.nameSupervisor }}</td>
                </tr>
                <tr>
                  <td>Adresse:</td>
                  <td>
                    {{ muttizettelDetails.streetSupervisor }}<br>
                    {{ muttizettelDetails.plzSupervisor }} {{ muttizettelDetails.citySupervisor }}<br>
                    {{ muttizettelDetails.countrySupervisor }}
                  </td>
                </tr>
                <tr>
                  <td>Geburtstag:</td>
                  <td>{{ muttizettelDetails.dobSupervisor.split('-')[2] + '.' + muttizettelDetails.dobSupervisor.split('-')[1] + '.' + muttizettelDetails.dobSupervisor.split('-')[0] }}</td>
                </tr>
                <tr>
                  <td>Telefonnummer:</td>
                  <td>{{ muttizettelDetails.phoneSupervisor }}</td>
                </tr>
                <tr>
                  <td>E-Mail-Adresse:</td>
                  <td>{{ muttizettelDetails.emailSupervisor }}</td>
                </tr>
              </table>
              <div class="pad-4" />
              <b class="f-bold">Unterschrift:</b>
              <img :src="muttizettelDetails.signature2" class="responsive-img br-10" style="background-color: #ffffff33;">
              <div class="pad-8" />
              <b class="f-bold">Daten von deines Erziehungsberechtigten</b>
              <table style="width: 100%;">
                <tr>
                  <td>Name:</td>
                  <td>{{ muttizettelDetails.nameParent }}</td>
                </tr>
                <tr>
                  <td>Adresse:</td>
                  <td>
                    {{ muttizettelDetails.streetParent }}<br>
                    {{ muttizettelDetails.plzParent }} {{ muttizettelDetails.cityParent }}<br>
                    {{ muttizettelDetails.countryParent }}
                  </td>
                </tr>
                <tr>
                  <td>Geburtstag:</td>
                  <td>{{ muttizettelDetails.dobParent.split('-')[2] + '.' + muttizettelDetails.dobParent.split('-')[1] + '.' + muttizettelDetails.dobParent.split('-')[0] }}</td>
                </tr>
                <tr>
                  <td>Telefonnummer:</td>
                  <td>{{ muttizettelDetails.phoneParent }}</td>
                </tr>
              </table>
              <div class="pad-4" />
              <b class="f-bold">Unterschrift:</b>
              <img :src="muttizettelDetails.signature" class="responsive-img br-10" style="background-color: #ffffff33;">
            </div>
            <p v-if="sendSuccess" style="font-size: 0.9em" class="color-blue t-center">
              E-Mail erfolgreich versendet
            </p>
            <div class="pad-4" />
            <button @click="send(muttizettelDetails)" class="button bgcolor-blue color-white fluid">
              Muttizettel an meine E-Mail senden
              <span style="display: block; font-size: 0.95em; text-transform: lowercase;">({{ user.email }})</span>
            </button>
            <div class="pad-4" />
            <button @click="detailsModal = false;" class="button bgcolor-black color-white fluid">
              Schließen
            </button>
          </div>
        </div>
      </transition>
    </main>
  </div>
</template>

<script>
import {authStore} from "@/store/authStore";
import {configStore} from "@/store/configStore";
import {userStore} from "@/store/userStore";
import { VueSignaturePad } from 'vue-signature-pad';

export default {
  name: "Muttizettel",
  title: "Muttizettel",
  components: {
    VueSignaturePad,
  },
  setup() {
    const auth = authStore()
    const config = configStore()
    const user = userStore()

    return {auth, config, user}
  },
  data(){
    return{
      page: 'overview',
      step: 0,
      eventId: '',
      parentName:'',
      parentAddress:'',
      parentCity:'',
      parentPlz:'',
      parentCountry:'Deutschland',
      parentPhone:'',
      parentBirthyday:null,
      username: this.user.firstname+' '+this.user.lastname,
      address:'',
      city:'',
      plz:'',
      country:'Deutschland',
      phone: this.user.phone,
      birthyday: null,
      supervisorLater: false,
      signatureLaterCheck: false,
      supervisorName:'',
      supervisorAddress:'',
      supervisorCity:'',
      supervisorPlz:'',
      supervisorCountry:'Deutschland',
      supervisorEmail:'',
      supervisorPhone:'',
      supervisorBirthyday:null,
      signature:'',
      signature2:'',
      sendEmail: this.user.email,
      privacy: false,
      newsletter: false,
      muttizettelList: [],
      events: [],
      detailsModal: false,
      muttizettelDetails: '',
      today18:new Date(Date.now()).setFullYear(new Date(Date.now()).getFullYear()-18),
      today16:new Date(Date.now()).setFullYear(new Date(Date.now()).getFullYear()-16),
      saveInApp: 0,
      sendSuccess: false,

      errors:{
        locationName:false,
        eventDate:false,
        parentName:false,
        parentAddress:false,
        parentCity:false,
        parentPlz:false,
        parentCountry:false,
        parentPhone:false,
        parentBirthday:false,
        username:false,
        address:false,
        city:false,
        plz:false,
        country:false,
        phone:false,
        birthday:false,
        birthdayMessage:'',
        supervisorName:false,
        supervisorAddress:false,
        supervisorCity:false,
        supervisorPlz:false,
        supervisorCountry:false,
        supervisorEmail:false,
        supervisorPhone:false,
        supervisorBirthyday:false,
        supervisorBirthydayMessage:'',
        signature:false,
        signature2:false,
        signatureLater:false,
        sendEmail: false
      },


    }
  },
  mounted() {
    this.config.loading = false
    this.loadEvents()
    this.loadParentData()
    this.loadMuttizettel()
    this.checkAutofill()
  },
  methods:{
    loadParentData(){
      const _this = this
      const fD = new FormData()
      fD.append('sessionID', this.auth.sessionID)
      this.axios.post('muttizettel/getParentData', fD)
          .then((response) => {
            if(response.status === 250){
              _this.parentName = response.data.nameParent
              _this.parentAddress = response.data.streetParent
              _this.parentCity = response.data.cityParent
              _this.parentPlz = response.data.plzParent
              _this.parentCountry = response.data.countryParent
              _this.parentPhone = response.data.phoneParent
              _this.parentBirthyday = response.data.dobParent
            }
          })
    },
    checkAutofill(){
      if(this.$route.query.event){
        this.feedback = 'successOrder';
        this.page = 'new'
        this.step = 1
        this.eventId = this.$route.query.event
      }
    },
    openDetails(id){
      this.sendSuccess = false
      const _this = this
      const fD = new FormData()
      fD.append('id', id)
      fD.append('sessionID', this.auth.sessionID)
      this.axios.post('muttizettel/getMuttizettelById', fD)
          .then((response) => {
            if(response.status === 250){
              _this.detailsModal = true;
              _this.muttizettelDetails = response.data;
            }
          })
    },
    loadMuttizettel(){
      const _this = this
      const fD = new FormData()
      fD.append('sessionID', this.auth.sessionID)
      this.axios.post('muttizettel/getMuttizettel', fD)
          .then((response) => {
            if(response.status === 250){
              _this.muttizettelList = response.data;
            }
          })
    },
    loadEvents(){
      const _this = this
      this.axios.post('muttizettel/getEvents')
          .then((response) => {
            if(response.status === 250){
              _this.events = response.data;
            }
          })
    },
    checkStep(){
      switch (this.step){
        case 0:{
          if (!this.eventId){this.errors.eventId = true}
          if (this.eventId){
            this.step = 1
            this.progressbar(this.step)
            break;
          }
          return
        }
        case 1:{
          if (!this.parentName){this.errors.parentName = true}
          if (!this.parentAddress){this.errors.parentAddress = true}
          if (!this.parentCity){this.errors.parentCity = true}
          if (!this.parentPlz){this.errors.parentPlz = true}
          if (!this.parentCountry){this.errors.parentCountry = true}
          if (!this.parentPhone){this.errors.parentPhone = true}
          if (!this.parentBirthyday){this.errors.parentBirthday = true}
          if (this.parentName && this.parentAddress && this.parentCity && this.parentPlz && this.parentCountry && this.parentPhone && this.parentBirthyday){
            this.step = 2
            this.progressbar(this.step)
            break;
          }
          return
        }
        case 2:{
          if (!this.username){this.errors.username = true}
          if (!this.address){this.errors.address = true}
          if (!this.city){this.errors.city = true}
          if (!this.plz){this.errors.plz = true}
          if (!this.country){this.errors.country = true}
          if (!this.phone){this.errors.phone = true}
          if (!this.birthyday){this.errors.birthday = true}
          if (new Date(this.birthyday) < new Date(this.today18)){
            this.errors.birthday = true
            this.errors.birthdayMessage = 'Du bist bereits über 18'
          }
          if (new Date(this.birthyday) > new Date(this.today16)){
            this.errors.birthday = true
            this.errors.birthdayMessage = 'Du bist noch keine 16'

          }
          if (this.username && this.address && this.city && this.plz && this.country && this.phone && this.birthyday && !this.errors.birthday ){
            this.step = 3
            this.progressbar(this.step)
            break;
          }
          return
        }
        case 3:{
          if (!this.supervisorName){this.errors.supervisorName = true}
          if (!this.supervisorAddress){this.errors.supervisorAddress = true}
          if (!this.supervisorCity){this.errors.supervisorCity = true}
          if (!this.supervisorPlz){this.errors.supervisorPlz = true}
          if (!this.supervisorCountry){this.errors.supervisorCountry = true}
          if (!this.supervisorPhone){this.errors.supervisorPhone = true}
          if (!this.supervisorEmail){this.errors.supervisorEmail = true}
          if (!this.supervisorBirthyday){this.errors.supervisorBirthday = true}
          if (new Date(this.supervisorBirthyday) > new Date(this.today18)){
            this.errors.supervisorBirthyday = true
            this.errors.supervisorBirthydayMessage = 'Du bist unter 18 Jahre'
          }
          if (this.supervisorName && this.supervisorAddress && this.supervisorCity && this.supervisorPlz && this.supervisorCountry && this.supervisorPhone && this.supervisorEmail && this.supervisorBirthyday && !this.errors.supervisorBirthyday || this.supervisorLater){
            this.step = 4
            this.progressbar(this.step)
            break;
          }
          return
        }
        case 4:{
          if (!this.errors.signatureLater){
            this.save()
            this.save2()
          }
          if (!this.signature && this.errors.signatureLater){this.errors.signature = true}
          if (!this.signature2 && this.errors.signatureLater){this.errors.signature2 = true}

          if (this.errors.signatureLater || this.signature && this.signature2){
            this.step = 5
            this.progressbar(this.step)
            break;
          }
          return
        }
        case 5:{
          if (!this.sendEmail){this.errors.sendEmail = true}
          if (!this.privacy){this.errors.privacy = true}
          if (this.privacy && this.sendEmail){
            if(this.supervisorLater == false && this.signatureLaterCheck == false && this.signature != '' && this.signature2 != '' && this.user.email){
              this.create(1)
              this.saveInApp = 1
              this.step = 6
            }else{
              this.create(0)
              this.saveInApp = 0
              this.step = 6
            }
            break;
          }
          return
        }
      }
    },
    progressbar(step){
      const progressBar = document.querySelector("#progressBar")
      let width = 100/ (175 / progressBar.offsetWidth)
      const startanimation = setInterval(()=>{animate(step)},10)
      function animate(step){
        if (width >= (step) * 20){
          clearInterval(startanimation)
        }
        else{
          width ++
          progressBar.style.width = width + "%";
        }
      }
    },
    undo() {
      this.$refs.signaturePad.undoSignature();
    },
    undo2() {
      this.$refs.signaturePad2.undoSignature();
    },
    create(saveInApp){
      const _this = this
      const fD = new FormData()
      fD.append('sessionID', this.auth.sessionID)
      fD.append('eventId', this.eventId)
      fD.append('nameParent', this.parentName)
      fD.append('streetParent', this.parentAddress)
      fD.append('plzParent', this.parentPlz)
      fD.append('cityParent', this.parentCity)
      fD.append('countryParent', this.parentCountry)
      fD.append('phoneParent', this.parentPhone)
      fD.append('dobParent', this.parentBirthyday)
      fD.append('nameUser', this.username)
      fD.append('streetUser', this.address)
      fD.append('plzUser', this.plz)
      fD.append('cityUser', this.city)
      fD.append('countryUser', this.country)
      fD.append('phoneUser', this.phone)
      fD.append('dobUser', this.birthyday)
      fD.append('nameSupervisor', this.supervisorName)
      fD.append('streetSupervisor', this.supervisorAddress)
      fD.append('plzSupervisor', this.supervisorPlz)
      fD.append('citySupervisor', this.supervisorCity)
      fD.append('countrySupervisor', this.supervisorCountry)
      fD.append('emailSupervisor', this.supervisorEmail)
      fD.append('phoneSupervisor', this.supervisorPhone)
      fD.append('dobSupervisor', this.supervisorBirthyday)
      fD.append('signature', this.signature)
      fD.append('signature2', this.signature2)
      fD.append('emailUser', this.sendEmail)
      fD.append('newsletter', this.newsletter)
      fD.append('saveInApp', saveInApp)
      this.axios.post(this.config.projectURL + 'muttizettel/create', fD)
          .then(response => {
            if(response.status === 250){}
          })
          .catch(e => {
            console.error(e)
          })
    },
    send(muttizettelDetails){
      const _this = this
      const fD = new FormData()
      fD.append('sessionID', this.auth.sessionID)
      fD.append('id', this.muttizettelDetails.id)
      fD.append('eventId', this.muttizettelDetails.eventId)
      fD.append('nameParent', this.muttizettelDetails.nameParent)
      fD.append('streetParent', this.muttizettelDetails.streetParent)
      fD.append('plzParent', this.muttizettelDetails.plzParent)
      fD.append('cityParent', this.muttizettelDetails.cityParent)
      fD.append('countryParent', this.muttizettelDetails.countryParent)
      fD.append('phoneParent', this.muttizettelDetails.phoneParent)
      fD.append('dobParent', this.muttizettelDetails.dobParent)
      fD.append('nameUser', this.muttizettelDetails.nameUser)
      fD.append('streetUser', this.muttizettelDetails.streetUser)
      fD.append('plzUser', this.muttizettelDetails.plzUser)
      fD.append('cityUser', this.muttizettelDetails.cityUser)
      fD.append('countryUser', this.muttizettelDetails.countryUser)
      fD.append('phoneUser', this.muttizettelDetails.phoneUser)
      fD.append('dobUser', this.muttizettelDetails.dobUser)
      fD.append('nameSupervisor', this.muttizettelDetails.nameSupervisor)
      fD.append('streetSupervisor', this.muttizettelDetails.streetSupervisor)
      fD.append('plzSupervisor', this.muttizettelDetails.plzSupervisor)
      fD.append('citySupervisor', this.muttizettelDetails.citySupervisor)
      fD.append('countrySupervisor', this.muttizettelDetails.countrySupervisor)
      fD.append('emailSupervisor', this.muttizettelDetails.emailSupervisor)
      fD.append('phoneSupervisor', this.muttizettelDetails.phoneSupervisor)
      fD.append('dobSupervisor', this.muttizettelDetails.dobSupervisor)
      fD.append('signature', this.muttizettelDetails.signature)
      fD.append('signature2', this.muttizettelDetails.signature2)
      fD.append('emailUser', this.muttizettelDetails.emailUser)
      fD.append('newsletter', this.muttizettelDetails.newsletter)
      fD.append('saveInApp', this.muttizettelDetails.saveInApp)
      this.axios.post(this.config.projectURL + 'muttizettel/send', fD)
          .then(response => {
            if(response.status === 250){
              _this.sendSuccess = true
            }
          })
          .catch(e => {
            console.error(e)
          })
    },
    save() {
      const { isEmpty, data } = this.$refs.signaturePad.saveSignature();
      this.signature = data
      this.errors.signature = false
    },
    save2() {
      const { isEmpty, data } = this.$refs.signaturePad2.saveSignature();
      this.signature2 = data
      this.errors.signature = false
    },
    signatureLater($event){
      if ($event.target.checked){
        this.errors.signatureLater=true
      }
      else{
        this.errors.signatureLater=false
      }
    }
  }
}
</script>

<style scoped>
#detailsModal{
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 50;
  background-color: #00000095;
}
.vueModalInner{
  width: calc(100% - 32px);
  max-width: 400px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 10px;
  padding: 16px;
}
#detailsModal table{
  margin-top: 4px;
}
#detailsModal tr td{
  padding-bottom: 8px;
}
.progressBox{
  background-color: #BDBDBD;
  width: 175px;
  height: 4px;
  border-radius: 2px;
}
#progressBar{
  background-color: #2068ff;
  height: 4px;
  width: 0%;
  border-radius: 2px;
}
.color-red{
  color: #c02b0a;
  display: inline-block;
  font-size: 12px;
  padding-left: 0.125em;
}
.errorInput{
  border: 2px #c02b0a solid !important;
}
.field.simple{
  margin-bottom: 12px;
}
.field.simple input,
.field.simple select{
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  background-color: #00000080;
  border-radius: 8px;
  color: #ffffff;
}
</style>